// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main[data-v-41d792d7] {\n  width: 1200px;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
